import React from 'react';
import PropTypes from 'prop-types';
import InfoRow from '../InfoRow';
import T from 'i18n-react';
import Dialog from './Dialog';
import SimpleSnackbar from '../../../core/Snackbar/SimpleSnackbar';
import { CERTIFICATE_STATUSES } from '../../../core/variables';

const Row = ({ certificate, isNeedUpload }) => {
  const [open, setOpen] = React.useState(false);
  const [status, setStatus] = React.useState(certificate.status);
  const snackbarRef = React.useRef();

  const isNew =
    [CERTIFICATE_STATUSES.UNCERTIFIED, CERTIFICATE_STATUSES.REJECTED].includes(
      status,
    ) && isNeedUpload;
  const handleButtonClick = () => setOpen(true);

  const getText = () => {
    // 提出済み
    // ステータスがrejectedであり、プロフィール変更リクエストアイテムが存在しない場合に処理される
    if (status === CERTIFICATE_STATUSES.REJECTED && !isNeedUpload) {
      return T.translate('user.certificates.statuses.confirming');
    }
    // 再提出が必要です
    if (status === CERTIFICATE_STATUSES.REJECTED) {
      return T.translate('user.certificates.requireSubmit');
    }
    return T.translate(`user.certificates.statuses.${status}`);
  };
  const text = getText();

  return (
    <>
      <InfoRow
        loaded
        title={T.translate('user.certificate')}
        text={text}
        isNewChecker={() => isNew}
        newText={T.translate('registerX', {
          x: T.translate('user.certificate'),
        })}
        onButtonClick={isNew ? handleButtonClick : null}
        prompt={isNew}
      />
      <Dialog
        open={open}
        setOpen={setOpen}
        setStatus={setStatus}
        snackbarRef={snackbarRef}
      />
      <SimpleSnackbar ref={snackbarRef} />
    </>
  );
};

Row.propTypes = {
  certificate: PropTypes.shape({
    status: PropTypes.string,
  }),
};

export default Row;
